import { HStack } from '@chakra-ui/react';
import type { Editor } from '@tiptap/core';
import { BubbleMenu } from '@tiptap/react';
import { Trash2 } from 'lucide-react';
import { FormatButton } from './FormatButton';

export function VideoBubbleMenu({ editor }: { editor: Editor | null }) {
  if (!editor || !editor.isEditable) {
    return null;
  }

  return (
    <BubbleMenu
      editor={editor}
      tippyOptions={{
        placement: 'top',
        offset: [0, 10],
      }}
      shouldShow={() => editor.isActive('video') || editor.isActive('youtube')}
    >
      <HStack
        gap={0.5}
        bg="bg.surface"
        shadow="sm"
        outline="1px"
        p={0.5}
        borderRadius="md"
        borderWidth="1px"
        boxShadow="sm"
      >
        <FormatButton
          label="delete image"
          aria-label="delete image"
          icon={Trash2}
          onClick={() => editor.commands.deleteSelection()}
          isActive={false}
        />
      </HStack>
    </BubbleMenu>
  );
}
